import React from 'react';
import { ReactComponent as IconClose } from 'imgs/svg-icons/IconClose.svg';

import './FilterCheckbox.css';

interface FilterCheckboxProps {
  title: string;
  selected?: boolean;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FilterCheckbox = ({ title, selected = false, disabled = false, onChange }: FilterCheckboxProps) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onChange(event as unknown as React.ChangeEvent<HTMLInputElement>);
    }
  };

  return (
    <label className="FilterCheckbox" tabIndex={disabled ? -1 : 0} onKeyDown={handleKeyDown}>
      {title}
      <input
        type="checkbox"
        className="FilterCheckbox__input"
        disabled={disabled}
        checked={selected}
        onChange={onChange}
      />
      <IconClose className="FilterCheckbox__icon" />
    </label>
  );
};

export default FilterCheckbox;
